import api from "./api";

const extractData = (res) => res?.data?.data ?? res?.data ?? null;

export async function fetchBuyerSupplierRatings(purchaseOrderIds = []) {
  const ids = [...new Set((purchaseOrderIds || []).map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0))];
  if (!ids.length) return [];
  const res = await api.get("/purchase-order/buyer/supplier-ratings", {
    params: { purchaseOrderIds: ids.join(",") },
  });
  const data = extractData(res);
  return Array.isArray(data?.ratings) ? data.ratings : [];
}

export async function fetchSupplierPurchaseOrderRating(purchaseOrderId) {
  const res = await api.get(`/purchase-order/${purchaseOrderId}/supplier-rating`);
  const data = extractData(res);
  return data?.rating ?? null;
}

export async function submitSupplierPurchaseOrderRating(purchaseOrderId, payload = {}) {
  const res = await api.post(`/purchase-order/${purchaseOrderId}/supplier-rating`, payload);
  const data = extractData(res);
  return data?.rating ?? data;
}
